import { ApiWidgetMetric } from "@/types/reporting/reporting.types.ts";

export const metricLabelSuffix = (metric: ApiWidgetMetric): string => {
  switch (metric) {
    case ApiWidgetMetric.headcount:
      return "headcount";
    case ApiWidgetMetric.headcount_growth_rate:
      return "growth";
    case ApiWidgetMetric.turnover_rate:
      return "turnover";
    case ApiWidgetMetric.attrition_rate:
      return "attrition";
    case ApiWidgetMetric.retention_rate:
      return "retention";
    case ApiWidgetMetric.average_tenure:
      return "tenure";
    case ApiWidgetMetric.average_age:
      return "age";
    default:
      return "turnover";
  }
};
